import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import DnaWelcome from 'on_web/components/onboarding/dna/DnaWelcome';
import DnaStep1ForPce from 'on_web/components/pceonboarding/dna/DnaStep1ForPce';
import DnaProviderSelection from 'on_web/components/onboarding/dna/DnaProviderSelection';
import DnaFileDownloadInstructions from 'on_web/components/onboarding/dna/DnaFileDownloadInstructions';
import DnaUploadFile from 'on_web/components/onboarding/dna/DnaUploadFile';
import DnaProcessing from 'on_web/components/onboarding/dna/DnaProcessing';
import DnaPurchaseDnaKit from 'on_web/components/onboarding/dna/DnaPurchaseDnaKit';

import PageItemContainer from 'on_web/components/shared/Common/PageItemContainer/PageItemContainer';

import {
  ROUTE_PCE_ONBOARDING_INTRO,
  ROUTE_ONBOARDING_DNA_INSTRUCTIONS,
  ROUTE_PCE_ONBOARDING_GENERAL,
} from 'routes';
import { getRedirectRoutePce } from '../helpers/redirectHelper';

import useUsersApi from '../hooks/useUsersApi';
import UserProfileContext from 'on_web/context/userProfileContext';

export default function PceOnboardingDna(props) {
  const [visibleStep, setVisibleStep] = useState(
    props.location.state ? null : 0
  );
  const [selectedFile, setSelectedFile] = useState();
  const [uploadProgress, setUploadProgress] = useState(0);

  const [
    { response, loading, getUserData, saveUserData, getGenotype, saveGenotype },
  ] = useUsersApi();

  useEffect(() => {
    getUserData().then(userData => {
      if (userData !== null) {
        if (visibleStep == null && props.location.state.startFromLast) {
          return setVisibleStep(1);
        } else if (userData.user_metadata.dnaUsageOption === '1') {
          setVisibleStep(2);
        } else if (userData.user_metadata.dnaUsageOption === '2') {
          props.history.push({
            pathname: ROUTE_ONBOARDING_DNA_INSTRUCTIONS,
            state: {
              forPce: true,
            },
          });
        } else {
          const route = getRedirectRoutePce(userData.user_metadata);
          props.history.push(route);
        }
      }
    });
  }, [getUserData]);

  const screenShouldBeVisible = screenIndex => {
    //TODO: (Damir) implement visibleScreensCount = 4 (or 1 on mobile)
    // return currentStep <= screenIndex && visibleScreensCount - screenIndex >=0
    return visibleStep === screenIndex;
  };

  const onWelcome = () => {
    setVisibleStep(visibleStep + 1);
  };

  const handleNextClick = userMetaData => {
    response.user_metadata = userMetaData;
    saveUserData(response);
    setVisibleStep(visibleStep + 1);
  };

  const handleStep1Payload = userMetadata => {
    response.user_metadata = userMetadata;
    saveUserData(response);
    if (userMetadata.dnaUsageOption === '1') {
      setVisibleStep(visibleStep + 1);
    } else if (userMetadata.dnaUsageOption === '2') {
      props.history.push({
        pathname: ROUTE_ONBOARDING_DNA_INSTRUCTIONS,
        state: { forPce: true },
      });
    } else {
      setVisibleStep(6);
    }
  };

  const onFileUpload = file => {
    setSelectedFile(file);
    setVisibleStep(visibleStep + 1);

    const params = {
      fileupload: {
        content_type: file.type,
        method: 'PUT',
        original_filename: file.name,
      },
    };
    saveGenotype(params)
      .then(() => {
        return getGenotype();
      })
      .then(resp => {
        const uploadUrl = resp.source_details.upload_url;

        const xhr = new XMLHttpRequest();
        xhr.open('PUT', uploadUrl, true);

        xhr.upload.onprogress = ev => {
          setUploadProgress((ev.loaded * 100) / ev.total);
        };

        xhr.onload = () => {
          const status = xhr.status;
          if (status === 200) {
            setUploadProgress(100);
          }
        };

        xhr.onerror = err => {
          console.log(err);
          setUploadProgress(100);
        };
        xhr.setRequestHeader('Content-Type', file.type);
        xhr.send(file);
      });
  };

  return (
    <div>
      <Grid
        container={useMediaQuery('(min-width:1000px)')}
        direction="row"
        justify="center"
        alignItems="center"
      >
        {loading === false && response && (
          <UserProfileContext.Provider value={response}>
            {screenShouldBeVisible(0) && (
              <PageItemContainer>
                <DnaWelcome onWelcome={() => onWelcome()} />
              </PageItemContainer>
            )}
            {screenShouldBeVisible(1) && (
              <PageItemContainer>
                <DnaStep1ForPce
                  onClickNext={payload => handleStep1Payload(payload)}
                  onClickBack={() =>
                    props.history.push({
                      pathname: ROUTE_PCE_ONBOARDING_INTRO,
                      state: {
                        startFromLast: true,
                      },
                    })
                  }
                />
              </PageItemContainer>
            )}
            {screenShouldBeVisible(2) && (
              <PageItemContainer>
                <DnaProviderSelection
                  onClickNext={userMetaData => handleNextClick(userMetaData)}
                  onClickBack={() => setVisibleStep(visibleStep - 1)}
                  forPce
                />
              </PageItemContainer>
            )}
            {screenShouldBeVisible(3) && (
              <PageItemContainer>
                <DnaFileDownloadInstructions
                  onClickNext={userMetaData => handleNextClick(userMetaData)}
                  onClickBack={() => setVisibleStep(visibleStep - 1)}
                  forPce
                />
              </PageItemContainer>
            )}
            {screenShouldBeVisible(4) && (
              <PageItemContainer>
                <DnaUploadFile
                  onClickNext={e => onFileUpload(e)}
                  onClickBack={() => setVisibleStep(visibleStep - 1)}
                  forPce
                />
              </PageItemContainer>
            )}
            {screenShouldBeVisible(5) && (
              <PageItemContainer>
                <DnaProcessing
                  selectedFile={selectedFile}
                  progress={uploadProgress}
                  onClickNext={() =>
                    props.history.push(ROUTE_PCE_ONBOARDING_GENERAL)
                  }
                  onClickBack={() => setVisibleStep(visibleStep - 1)}
                  forPce
                />
              </PageItemContainer>
            )}
            {screenShouldBeVisible(6) && (
              <PageItemContainer>
                <DnaPurchaseDnaKit
                  onClickNext={() =>
                    props.history.push(ROUTE_PCE_ONBOARDING_GENERAL)
                  }
                  onClickBack={() => setVisibleStep(1)}
                  forPce
                />
              </PageItemContainer>
            )}
          </UserProfileContext.Provider>
        )}
      </Grid>
    </div>
  );
}
